export interface PasswordValidationResult {
  passwordsMatch: boolean
  lengthRequirementMet: boolean
  lowercaseRequirementMet: boolean
  uppercaseRequirementMet: boolean
  numberRequirementMet: boolean
  specialCharRequirementMet: boolean
  allRequirementsMet: boolean
  doesNotContainScandicLetters: boolean
}

export const validatePasswords = (
  password: string,
  passwordAgain: string
): PasswordValidationResult => {
  const validationResult = {
    passwordsMatch: password === passwordAgain,
    lengthRequirementMet: password.length >= 8,
    lowercaseRequirementMet: /[a-z]/.test(password),
    uppercaseRequirementMet: /[A-Z]/.test(password),
    numberRequirementMet: /[0-9]/.test(password),
    specialCharRequirementMet: /[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/.test(
      password
    ),
    doesNotContainScandicLetters: !/[äöåÄÖÅ]/.test(password),
  }

  const allRequirementsMet =
    validationResult.lengthRequirementMet &&
    validationResult.lowercaseRequirementMet &&
    validationResult.uppercaseRequirementMet &&
    validationResult.numberRequirementMet &&
    validationResult.specialCharRequirementMet &&
    validationResult.doesNotContainScandicLetters

  return {
    ...validationResult,
    allRequirementsMet,
  }
}
